import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div ...attributes>\n  {{yield}}\n</div>\n",{ moduleName: "seshy/components/bounce-player/wavesurfer/timeline.hbs" })